import React, {useState} from "react";
import {useTheme} from "connectui/theme/ThemeProvider";
import FlexContainer from "connectui/component/layout/FlexContainer";
import MessageFile from "./MessageFile";

const MAX_ATTACHMENTS_PREVIEWS = 4;

const FilesRow = ({attachments, openMobileLink}) => {
  const {theme} = useTheme();
  const [showAll, setShowAll] = useState(false);

  return (
    <FlexContainer flexDirection="row" gap={theme.spacing(2.5)}>
      {attachments.map((attachment, index) => {
        if (!showAll && index >= MAX_ATTACHMENTS_PREVIEWS) {
          return null;
        }

        return (
          <MessageFile
            key={attachment.link}
            attachment={attachment}
            showMore={
              !showAll &&
              index === MAX_ATTACHMENTS_PREVIEWS - 1 &&
              attachments.length - MAX_ATTACHMENTS_PREVIEWS
            }
            setShowMore={setShowAll}
            onMobileClick={openMobileLink}
          />
        );
      })}
    </FlexContainer>
  );
};

export default FilesRow;
